
    <video #videoPlayer class="video-js video-style" [ngClass]="{'mini-video-js': miniVideo}" controls poster="{{posterPath}}" muted playsinline disablePictureInPicture oncontextmenu = "return false" preload="none">
		<source src="{{videoSource}}" type="{{videoType}}">
	</video>
  